import { render, staticRenderFns } from "./CartAlert.vue?vue&type=template&id=70348063"
import script from "./CartAlert.vue?vue&type=script&lang=js"
export * from "./CartAlert.vue?vue&type=script&lang=js"
import style0 from "./CartAlert.vue?vue&type=style&index=0&id=70348063&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports